import React from 'react';
import { useConfigService } from '@thd-nucleus/experience-context';
import { useTheme } from '@thd-olt-component-react/theme-provider';
import { bool } from 'prop-types';
import { BuyAgain } from '@thd-olt-component-react/buy-again';
import { RecentPurchases } from '../recent-purchases-history/recent-purchases';
import { ProductList } from '../product-list/product-list';
import { StoreDetails } from '../store-details/store-details';
import { LoyaltyBenefits } from '../loyalty-benefits/loyalty-benefits';
import { MoreProXtraBenefits } from '../more-pro-xtra-benefits/more-pro-xtra-benefits';
import { PaintPurchaseHistoryContainer } from '../paint-purchase-history/paint-purchase-history';
export var DashboardRecentActivity = function (_a) {
    var isB2B = _a.isB2B, isMobile = _a.isMobile;
    var theme = useTheme(DashboardRecentActivity);
    var _b = theme.props, hideLoyaltyBenefits = _b.hideLoyaltyBenefits, hideProductList = _b.hideProductList, hideMoreProXtraBenefits = _b.hideMoreProXtraBenefits, hideStoreDetails = _b.hideStoreDetails;
    var ENABLE_NEW_PAINT_EXPERIENCE = !!useConfigService('ENABLE_NEW_PAINT_EXPERIENCE');
    return (React.createElement("div", null,
        React.createElement("div", { className: "sui-grid sui-grid-cols-1 lg:sui-grid-cols-2 sui-gap-x-4 sui-gap-y-4 md:sui-gap-x-8 md:sui-gap-y-8" },
            React.createElement("div", { className: "sui-col-span-1 lg:sui-col-span-2" },
                React.createElement(RecentPurchases, { isB2B: isB2B })),
            isB2B && (React.createElement(React.Fragment, null,
                !hideLoyaltyBenefits && (React.createElement("div", { className: "sui-col-span-1" },
                    React.createElement(LoyaltyBenefits, null))),
                !hideMoreProXtraBenefits && (React.createElement("div", { className: "sui-col-span-1" },
                    React.createElement(MoreProXtraBenefits, null))),
                React.createElement("div", { className: "sui-col-span-1 lg:sui-col-span-2" },
                    React.createElement(BuyAgain, { noATCFulfillment: true, requestKey: "G4xP51k3Aw8tOEvGUKRHbmYW8cM9XrXX", showLoading: true, slidesToShow: { sm: 3, md: 4, lg: 4, xl: 5, '2xl': 6 }, hideTitle: true, showFallback: true })),
                ENABLE_NEW_PAINT_EXPERIENCE && (React.createElement("div", { className: "sui-col-span-1 lg:sui-col-span-2" },
                    React.createElement(PaintPurchaseHistoryContainer, null))))),
            !isB2B && ENABLE_NEW_PAINT_EXPERIENCE && (React.createElement("div", { className: "sm:sui-col-span-2" },
                React.createElement(PaintPurchaseHistoryContainer, null))),
            !isB2B && !hideProductList && (React.createElement("div", { className: "sm:sui-col-start-1" },
                React.createElement(ProductList, null))),
            !isB2B && !isMobile && !hideStoreDetails && (React.createElement("div", { className: "sm:sui-col-start-2" },
                React.createElement(StoreDetails, null))))));
};
DashboardRecentActivity.displayName = 'DashboardRecentActivity';
DashboardRecentActivity.themeProps = {
    hideLoyaltyBenefits: bool,
    hideProductList: bool,
    hideMoreProXtraBenefits: bool,
    hideStoreDetails: bool,
};
DashboardRecentActivity.defaultThemeProps = {
    hideLoyaltyBenefits: false,
    hideProductList: false,
    hideMoreProXtraBenefits: false,
    hideStoreDetails: false,
};
